export const CommonEmailDomains = [
  'gmail.com',
  'yahoo.com',
  'outlook.com',
  'icloud.com',
  'hotmail.com',
  'aol.com',
  'live.com',
  'msn.com',
];
